import React from 'react';
import { UploaderComponent } from '@syncfusion/ej2-react-inputs';
import './OpFileSelect.css';
import { CustomFileListTemplate } from './templates/CustomFileListTemplate';

export const OpFileSelect = ({
         allowedExtensions, // string with comma separators: '.mp3,.mp4'
         asteriskOn, // add * symbol to label
         label,
         multiple = false, // set to true if need to upload multiple files
         onSelectFile,
       }) => {
         const maxNumber = Number.MAX_SAFE_INTEGER;
         const uploaderRef = React.useRef(null);

         const handleSelectFile = (params) => {
           onSelectFile(params.filesData[0].rawFile);
         };

         return (
           <div className={"mt-2"}>
             {label && (
               <div className={"op-file-select-label"}>
                 {label}
                 {asteriskOn && <span style={{ color: "#FF0000" }}>*</span>}
               </div>
             )}
             <UploaderComponent
               allowedExtensions={allowedExtensions}
               autoUpload={false}
               buttons={{ browse: "Browse" }}
               cssClass={"e-custom-file-select"}
               id={"e-custom-file-select"}
               maxFileSize={maxNumber}
               multiple={multiple}
               ref={(e) => (uploaderRef.current = e)}
               selected={handleSelectFile}
               template={(params) =>
                 CustomFileListTemplate({
                   ...params,
                   ref: uploaderRef,
                   onSelectFile: onSelectFile,
                 })
               }
               type={"file"}
             />
           </div>
         );
       };